var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCypress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#4A4A4D;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.5,9C50.7,9,63,21.3,63,36.5S50.7,64,35.5,64C20.3,64,8,51.7,8,36.5S20.3,9,35.5,9L35.5,9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,48.6c-1,3.1-2.5,5.4-4.6,7.1c-2.1,1.7-4.9,2.6-8.4,2.9l-0.7-4.6c2.3-0.3,4-0.8,5.1-1.6 c0.4-0.3,1.2-1.2,1.2-1.2l0,0l-8.3-26.6h6.9l4.8,19.9l5.1-19.9h6.7L50.1,48.6L50.1,48.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26,23.7c1.6,0,3.1,0.2,4.3,0.7c1.3,0.5,2.5,1.2,3.7,2.2l-2.8,3.8c-0.8-0.6-1.6-1-2.3-1.3 c-0.7-0.3-1.6-0.4-2.4-0.4c-3.4,0-5.1,2.6-5.1,7.9c0,2.7,0.4,4.6,1.3,5.7c0.9,1.2,2.1,1.7,3.8,1.7c0.8,0,1.6-0.1,2.3-0.4 c0.7-0.3,1.5-0.7,2.5-1.3l2.8,4c-2.3,1.9-4.9,2.8-7.9,2.8c-2.4,0-4.4-0.5-6.2-1.5c-1.7-1-3.1-2.5-4-4.4c-0.9-1.9-1.4-4.1-1.4-6.7 c0-2.5,0.5-4.8,1.4-6.7c0.9-2,2.3-3.5,4-4.6C21.7,24.3,23.7,23.7,26,23.7L26,23.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCypress);
export default __webpack_public_path__ + "static/media/cypress.6206ea2eec1aa7b31313f0f28c9a1db6.svg";
export { ForwardRef as ReactComponent };